<template>
	<div>
		<link href='https://fonts.googleapis.com/css?family=Lato|GFS+Didot|Montserrat:400,700' rel='stylesheet' type='text/css' />
		<!-- <link rel="stylesheet" href="https://www.brightonretail.com/header_and_footer/2017-07-21/style.css?<?=time()?>" type="text/css" media="all" /> -->

		

		<table width="100%" border="0" cellpadding="0" cellspacing="0">
			<tr>
				<!-- <td bgcolor="#808080"><table align="center" border="0" cellpadding="0" cellspacing="0"> -->
				<td bgcolor="#808080"><table align="center" width="100%" border="0" cellpadding="0" cellspacing="0">
					<tr>
						<td>
							<div id="header">
								<!-- <a href="http://www.brightonretail.com/" class="logoLink"><img src="http://www.brightonretail.com/header_and_footer/grey/images/retail_logo.png" alt="Brighton Retailers" border="0" /></a> -->
								<a href="http://www.brightonretail.com/" class="logoLink"><img src="https://www.brightonretail.com/header_and_footer/grey/images/logo_2017.png" alt="Brighton Retailers" border="0" /></a>
								<!-- <form id="search">
									<input type="text"/><br/>
									<input type="text"/><button>Search</button>
								</form> -->
							</div>
						</td>
					</tr>
				</table></td>
			</tr>
		</table>
	</div>

</template>
<style scoped>
	#header{
		display:block;
	}
	#header a{
		display:block;
		margin:10px auto;
		text-align:left;
		max-width:1170px;
	}
	#header #search{
		display: inline-block;
		width: 50%;
		text-align: right;
	}
	#footer{
		text-align:center;
	}
	#footer ul{
		float: none;
	    display: inline-block
	}
			
</style>
<script>
	
export default {
  	name: 'brheader',
	props: {
		// storeType: Number
	}
}
</script>